// extracted by mini-css-extract-plugin
export default {"foot":"EmbedSheetFooter_foot__-ZVMS","note":"EmbedSheetFooter_note__1HM-S","secondary":"EmbedSheetFooter_secondary__tOcbn","primary":"EmbedSheetFooter_primary__P+OCE"};